/* eslint-disable import/prefer-default-export */
export const RenderIf = ({ children, isTrue }) => (isTrue ? children : null);
